import { userConstants } from "../constants/login.constants";

 function resetPassword(state = {}, action) {
    switch (action.type) {
        case userConstants.RESETPASSWORD_REQUEST:
            return {
                loading: true
            };
        case userConstants.RESETPASSWORD_SUCCESS:
            return {
                items: action.resetPassword
            };
        case userConstants.RESETPASSWORD_FAILURE:
            return {
                error: action.errorResetPassword
                
            };
        default:
            return state
    }
}
export default resetPassword;